module.exports = __webpack_public_path__ + "img/1.332ada33.jpg";